import { Icon } from "@grassrootly/rn-core";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { ScreenLayout } from "../../layout/components";
import { PlayerCreateGroup } from "../../components/shared";
import { useCreateGroup } from "./useCreateGroup";

export default function CreateGroupScreen({ navigation, route }: MainStackScreenProps<"create-group">) {
  const { createGroupForm, onSubmitCreateGroup } = useCreateGroup({ navigation });

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate("home_remastered");
  };

  return (
    <ScreenLayout
      header={{
        center: `CREATE GROUP`,
        left: <Icon name="arrow_back_ios" size={24} onPress={goBack} classNames={["mb-{5}"]} />,
      }}
    >
      <PlayerCreateGroup createGroupForm={createGroupForm} onSubmit={onSubmitCreateGroup} />
    </ScreenLayout>
  );
}
